module.exports = __webpack_public_path__ + "static/media/powerful-algorithms.cef10c7f.png";